import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNuqsQueryState } from '@shared/hooks';
import { Checkbox, Divider, Flex, Input, UiText } from '@shared/ui';
import {
    useIsUploadingStatus,
    useOrdersRecognitionContext,
} from '@widgets/OrdersRecognition/lib/hooks';
import { ORDERS_HIDE_PROCEEDED } from '@widgets/OrdersRecognition/model/сonsts';

import cls from './OrdersRecognitionHeader.module.css';

export const OrdersRecognitionHeader = () => {
    const { t } = useTranslation();
    // const [hideProcessed, toggleHideProcessed] = useToggleState(false);
    const { state, setState } = useNuqsQueryState(ORDERS_HIDE_PROCEEDED);
    const isUploading = useIsUploadingStatus();

    const { searchDraft, onChangeSearchDraft, commitSearchDraft } = useOrdersRecognitionContext();

    const toggleHideProcessed = () => {
        void setState(state === 'true' ? 'false' : 'true');
    };

    return (
        <header className={cls.sidebarHeader}>
            <UiText variant="subHeading" tag="h2" weight="bold">
                {t('OrderRecognition.Header.title.text')}
            </UiText>
            <UiText variant="mediumPlain" className={cls.sidebarDescription}>
                {t('OrderRecognition.Header.description.text')}
            </UiText>
            <Flex justify="between">
                <Flex>
                    <Input
                        placeholder={t('OrderRecognition.Header.searchInput.placeholder')}
                        inputClassName={cls.searchInput}
                        value={searchDraft}
                        onChange={(e) => onChangeSearchDraft(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                commitSearchDraft();
                            }
                        }}
                        // onChange={(e) => setSearchDraft(e.target.value)}
                        // onKeyDown={(e) => {
                        //     if (e.key === 'Enter') void onSubmitSearch();
                        // }}
                        disabled={isUploading}
                    />
                    {/* <UiButton */}
                    {/*    variant="outlined" */}
                    {/*    btnColor="ghost" */}
                    {/*    btnText={t('OrderRecognition.Header.searchInput.btn.text')} */}
                    {/*    className={cls.searchBtn} */}
                    {/*    onClick={onSubmitSearch} */}
                    {/* /> */}
                </Flex>
                <Checkbox
                    classes={cls.checkboxWrapper}
                    checkBoxClassName={cls.checkbox}
                    isActive={state === 'true'}
                    title={t('OrderRecognition.Header.HideProcessed.CheckboxLabel.text')}
                    onClick={toggleHideProcessed}
                    isDisabled={isUploading}
                />
            </Flex>
            <Divider classes={cls.divider} />
        </header>
    );
};
